import React, { useEffect, useRef } from "react";

import QRCodeStyling from "qr-code-styling";

const QRCodeComponent = () => {
  const qrContainer = useRef(null);

  useEffect(() => {
    const qrCode = new QRCodeStyling({
      width: 200,
      height: 200,
      data: "https://www.theraindropcompany.com",
      margin: 0,
      qrOptions: {
        // "typeNumber": "0",
        mode: "Byte",
        errorCorrectionLevel: "H",
      },
      dotsOptions: { type: "square", color: "#f75eab", gradient: null },
      backgroundOptions: { color: "#000000" },
      cornersSquareOptions: {
        type: "dots",
        color: "#f75eac",
        gradient: null,
      },
    });

    // qrCode.append(qrContainer.current);
    qrContainer.current.innerHTML = "";
    qrCode.append(qrContainer.current);
    // qrContainer.current.appendChild(qrCode.qrcode._canvas);
    // qrCode.
  }, []);

  return (
    <div ref={qrContainer} className="flex absolute scale-[45%] bg-black" />
  );
};

const CanvasWithDots = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height); // This will clear the canvas before each drawing

    // Dot generation code goes here.
    const dotCount = 20; // Adjust this as necessary
    for (let row = 0; row < dotCount; row++) {
      for (let col = 0; col < dotCount; col++) {
        // Generate a random x and y within the canvas bounds
        let x = (row / dotCount) * canvas.width;
        let y = (col / dotCount) * canvas.height;

        // Draw the dot
        ctx.beginPath();
        ctx.arc(x, y, 2, 0, 2 * Math.PI);
        ctx.fillStyle = "#EF5FA7";
        ctx.fill();
      }
    }

    ctx.beginPath();
    ctx.arc(
      canvas.width / 2,
      canvas.width / 2,
      canvas.width / 2,
      0,
      2 * Math.PI,
    );
    ctx.fillStyle = "#000000";
    ctx.lineWidth = 15;
    ctx.stroke();
  });

  return (
    <canvas className={"absolute"} ref={canvasRef} width={150} height={150} />
  );
};

const RaindropQRCode = () => {
  return (
    <div className="flex items-center justify-center absolute -z-10">
      <CanvasWithDots />
      <QRCodeComponent />
    </div>
  );
};

export default RaindropQRCode;
